import {Plugins} from '@packages/systems/wfdl';
import {getName} from '@packages/systems/wfdl-Qualified';
import {weakMemo} from '@packages/utilities/memo';
import {
  type ComponentLocalizationMap,
  ComponentLocalizations,
} from '@packages/domains/localization/dom/model';

export const evaluateComponentLocalizations = weakMemo(
  (plugins: Plugins.PluginsType) =>
    weakMemo(
      (map: ComponentLocalizationMap): Record<string, Record<string, any>> => {
        const evalEnv = Plugins.getEvalEnv(plugins);
        const localizations: Record<string, Record<string, any>> = {};
        map.forEach((component, qualifiedName) => {
          localizations[getName(qualifiedName)] =
            ComponentLocalizations.evaluate(component, evalEnv);
        });
        return localizations;
      }
    )
);
